<template>
  <div id="import-modal">
    <v-dialog :value="isModalActive" max-width="900" persistent @input="inputModal">
      <template v-if="isModalActive">
        <template v-if="listMode">
          <ImportModalListCard
            ref="ImportModalListCard"
            :type="type"
            @close="closeAndInit"
            @goImportMode="listMode = false"
            @goToImport="goToImport"
          />
        </template>
        <template v-else>
          <ImportModalUploadCard
            ref="ImportModalUploadCard"
            :myImport.sync="myImport"
            :type="type"
            @close="closeModal"
            @goListMode="listMode = true"
          />
          <ImportModalProcessingCard :myImport.sync="myImport" @close="closeAndInit" />
          <ImportModalRequiresDictCard :myImport.sync="myImport" :type="type" @close="closeModal" />
          <ImportModalProcessedCard
            :myImport.sync="myImport"
            :type="type"
            @close="closeAndInit"
            @goListMode="listMode = true"
          />

          <ImportModalErroredCard :myImport.sync="myImport" :type="type" @close="closeModal" />
        </template>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import modalMixin from '@/views/components/core/modalMixin.js'
import ImportModalUploadCard from './importModal/ImportModalUploadCard'
import ImportModalProcessingCard from './importModal/ImportModalProcessingCard'
import ImportModalRequiresDictCard from './importModal/ImportModalRequiresDictCard'
import ImportModalProcessedCard from './importModal/ImportModalProcessedCard'
import ImportModalErroredCard from './importModal/ImportModalErroredCard'
import ImportModalListCard from './importModal/ImportModalListCard'

export default {
  components: {
    ImportModalUploadCard,
    ImportModalProcessingCard,
    ImportModalRequiresDictCard,
    ImportModalProcessedCard,
    ImportModalErroredCard,
    ImportModalListCard,
  },
  mixins: [modalMixin],
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    myImport: {},
    listMode: false,
  }),
  watch: {},
  methods: {
    resetForm() {
      this.$set(this, 'myImport', { broker: null, file: null })
      this.listMode = false
    },
    closeAndInit() {
      this.closeModal()
      this.$emit('init')
    },
    preSelectBroker({ broker }) {
      if (this.$refs.ImportModalUploadCard)
        this.$refs.ImportModalUploadCard.preSelectBroker({ broker })
    },
    goToImport(myImport) {
      this.listMode = false
      this.$set(this, 'myImport', myImport)
    },
  },
}
</script>
